import {
  GET_NUMBER_OF_RECEIPTS_REQUEST,
  GET_NUMBER_OF_RECEIPTS_SUCCESS,
  GET_NUMBER_OF_RECEIPTS_FAIL,
  GET_RECEIPT_METAINFO_REQUEST,
  GET_RECEIPT_METAINFO_SUCCESS,
  GET_RECEIPT_METAINFO_FAIL,
  GET_RECEIPT_CATEGORY_REQUEST,
  GET_RECEIPT_CATEGORY_SUCCESS,
  GET_RECEIPT_CATEGORY_FAIL,
  GET_OWNER_UNIQUE_CUSTOMERS_REQUEST,
  GET_OWNER_UNIQUE_CUSTOMERS_SUCCESS,
  GET_OWNER_UNIQUE_CUSTOMERS_FAIL,
  GET_OWNER_DASHBOARD_STATS_REQUEST,
  GET_OWNER_DASHBOARD_STATS_SUCCESS,
  GET_OWNER_DASHBOARD_STATS_FAIL
} from '../constants/dashboardConstants.js'

export const countRcptReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_NUMBER_OF_RECEIPTS_REQUEST:
      return { loading: true }

    case GET_NUMBER_OF_RECEIPTS_SUCCESS:
      return { loading: false, countRecpt: action.payload }

    case GET_NUMBER_OF_RECEIPTS_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const getRcptMetaReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_RECEIPT_METAINFO_REQUEST:
      return { loading: true }

    case GET_RECEIPT_METAINFO_SUCCESS:
      return { loading: false, receiptMeta: action.payload }

    case GET_RECEIPT_METAINFO_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const getRcptCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_RECEIPT_CATEGORY_REQUEST:
      return { loading: true }

    case GET_RECEIPT_CATEGORY_SUCCESS:
      return { loading: false, rcptCategory: action.payload }

    case GET_RECEIPT_CATEGORY_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const ownerUniqueCustomersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_OWNER_UNIQUE_CUSTOMERS_REQUEST:
      return { loading: true }

    case GET_OWNER_UNIQUE_CUSTOMERS_SUCCESS:
      return { loading: false, uniqueCustomers: action.payload }

    case GET_OWNER_UNIQUE_CUSTOMERS_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const ownerDashboardStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_OWNER_DASHBOARD_STATS_REQUEST:
      return { loading: true }

    case GET_OWNER_DASHBOARD_STATS_SUCCESS:
      return { loading: false, ownerDashboardStats: action.payload }

    case GET_OWNER_DASHBOARD_STATS_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}
